'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.isLoadTime = isLoadTime;
exports.load = load;
exports.loadByKey = loadByKey;
exports.loadByKeyOnAcceptDaw = loadByKeyOnAcceptDaw;
exports.selectFormat = selectFormat;
exports.downloadTracks = downloadTracks;
exports.downloadFileFromKey = downloadFileFromKey;
exports.sendFeedback = sendFeedback;
exports.clearPlaylistError = clearPlaylistError;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _TypeCast = require('helpers/TypeCast');

var _playstats = require('./playstats');

var _auth = require('./auth');

var _responseCodes = require('helpers/responseCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECT_FORMAT = 'playlist/SELECT_FORMAT'; /* Playlist redux reducer and action creators */

var CLEAR_PLAYLIST_ERROR = 'playlist/CLEAR_PLAYLIST_ERROR';

var loadReducer = (0, _loadReducer2.default)('playlist', {
  playlist: {
    action: 'load',
    init: { album: {}, tracks: [], user: {} },
    fields: { album: 'project', tracks: 'tracks', user: 'user' }
  },
  downloadTracks: { init: null },
  downloadFileFromKey: {},
  sendFeedback: {}
});

var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
  format: 'mp3'
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case SELECT_FORMAT:
      return (0, _extends3.default)({}, state, {
        format: action.format
      });
    case CLEAR_PLAYLIST_ERROR:
      return (0, _extends3.default)({}, state, {
        playlistLoadError: null
      });
    default:
      return loadReducer.reducer(state, action);
  }
}

function isLoaded(globalState, id) {
  return (0, _get4.default)(globalState, ['playlist', 'playlistLoaded', id], false);
}

function isLoadTime(globalState, id) {
  return !isLoaded(globalState, id) && (0, _get4.default)(globalState, 'auth.user', false);
}

function setStatsOnLoad(data) {
  return function (dispatch) {
    var _data$project = data.project,
        project = _data$project === undefined ? {} : _data$project,
        _data$tracks = data.tracks,
        tracks = _data$tracks === undefined ? [] : _data$tracks;

    dispatch((0, _playstats.setData)({ albums: [project], albumsTracks: (0, _defineProperty3.default)({}, project.project_id, tracks) }));
    return data;
  };
}

function loadFromEndpoint(_ref) {
  var key = _ref.key,
      endpoint = _ref.endpoint,
      _ref$params = _ref.params,
      params = _ref$params === undefined ? {} : _ref$params;

  return function (dispatch) {
    return dispatch({
      types: loadReducer.constantsByKey.playlist,
      promise: function promise(client) {
        var result = client.post(endpoint, (0, _extends3.default)({ data: { key: key } }, params));
        result.promise.then(function (data) {
          return dispatch(setStatsOnLoad(data));
        }).catch(function (err) {
          return err;
        });
        return result;
      },
      key: key
    });
  };
}

function load(_ref2) {
  var key = _ref2.key;

  return function (dispatch) {
    return dispatch(loadFromEndpoint({ key: key, endpoint: 'viewer_wa/getCompleteAlbum' }));
  };
}

function loadByKey(_ref3) {
  var key = _ref3.key;

  var params = { hideErrorCodes: [_responseCodes.playlistCodes.loginRequired, _responseCodes.playlistCodes.notAvailable, _responseCodes.playlistCodes.contentLocked] };
  return function (dispatch) {
    return dispatch(loadFromEndpoint({ key: key, endpoint: 'auth/getAlbumFromKey', params: params }));
  };
}

function loadByKeyOnAcceptDaw(_ref4) {
  var key = _ref4.key;

  return function (dispatch) {
    return dispatch(loadFromEndpoint({ key: key, endpoint: 'auth/acceptDaw' }));
  };
}

function selectFormat(format) {
  return {
    type: SELECT_FORMAT,
    format: format
  };
}

function downloadTracks(_ref5) {
  var key = _ref5.key,
      _ref5$format = _ref5.format,
      format = _ref5$format === undefined ? 'mp3' : _ref5$format,
      tracks = _ref5.tracks,
      _ref5$getEstimation = _ref5.getEstimation,
      getEstimation = _ref5$getEstimation === undefined ? false : _ref5$getEstimation;

  return function (dispatch) {
    var params = { data: { key: key, fmt: format, downloadList: (0, _TypeCast.asPostArray)(tracks, true) }, successCodes: [3, 5] };
    var isUser = dispatch((0, _auth.isLoggedIn)());
    var endpoint = getEstimation ? isUser ? 'viewer_wa/getDownloadProcTime' : 'auth/getDownloadProcTime' : isUser ? 'viewer_wa/downloadFiles' : 'auth/downloadNonWatermarkFiles';

    return dispatch({
      types: loadReducer.constantsByKey.downloadTracks,
      promise: function promise(client) {
        return client.post(endpoint, params);
      },
      key: key,
      tracks: tracks,
      format: format
    });
  };
}

function downloadFileFromKey(key) {
  return {
    types: loadReducer.constantsByKey.downloadFileFromKey,
    promise: function promise(client) {
      return client.post('auth/dwnFileFromKey', { data: { key: key }, successCodes: [_responseCodes.downloadTracksCodes.needLogin] });
    },
    key: key
  };
}

function sendFeedback(_ref6) {
  var key = _ref6.key,
      feedbackText = _ref6.feedbackText;

  return {
    types: loadReducer.constantsByKey.sendFeedback,
    promise: function promise(client) {
      return client.post('auth/feedback', { data: { key: key, feedbackText: feedbackText } });
    },
    key: key,
    feedbackText: feedbackText
  };
}

function clearPlaylistError() {
  return {
    type: CLEAR_PLAYLIST_ERROR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/playlist.js
// module id = 217
// module chunks = 1